import { AccordionSummary, Dialog } from '@material-ui/core';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    width: 100%;
    display: flex;
    position: relative;
    max-width: 972px;
  }
  .success-close-icon {
    position: absolute;
    right: 15px;
    top: 15px;
  }

  .success-title {
    font-size: 14px;
    font-weight: 400;
    color: #172c51;
    line-height: 16.7px;
  }

  .success-actions {
    position: relative;
    padding: 5px;
    display: flex;
    flex-direction: row;
  }
  .success-actions > button {
    margin: 5px;
  }

  #secondary-button-style {
    margin: 20px 0;
    padding: 10px;
    color: #0075c9;
  }
  .primary-button {
    padding-left: 5px;
    color: #ffffff !important;
    border-color: #0075c9;
    background-color: #0075c9;
    &:hover {
      background-color: #0075c9;
      border: 1px solid #0075c9;
    }
    &:mui-disabled {
      color: #ffffff;
    }
  }

  .ChevronRightIcon {
    margin-left: 10px;
    fill: white;
  }
  .MuiDialogContent-root {
    padding: 24px 24px;
  }
`;

export const styledIcon = {
  marginTop: '5px',
};

interface StyledAccordionSummaryProps {
  bgColor: string;
  textColor: string;
}

export const StyledAccordionSummary = styled(AccordionSummary)<
  StyledAccordionSummaryProps
>`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  margin: 8px 0 !important;
  .request-icon {
    width: 25px;
    height: 19px;
    margin-top: 5px;
  }
`;

export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
  .field {
    width: 200px;
    border-bottom: 1px solid #dddddd;
    margin-right: 24px;
  }
  .label {
    color: #8b8b8b;
    font-size: 11px;
  }
  .value {
    padding: 8px 0;
    border-radius: 2px;
    font-weight: bold;
    font-size: 13px;
    color: #2b2727;
  }
  .expertise {
    margin-top: 16px;
    padding: 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
    min-height: 300px;
  }
  .pronouncing-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: 16px;
  }
  .box-field {
    padding: 18px 8px 8px 8px;
    border-radius: 8px;
    border: 1px solid #ebeef1;
    background-color: #f9fafa;
    margin-bottom: 20px;
  }
  .expertise-item {
    align-items: end;
    display: flex;
    flex-direction: column;
  }
  .expertise-title {
    font-weight: bold;
    font-size: 14px;
    color: #0072c6;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .list-container {
    padding-top: 16px;
  }

  .list-title {
    font-size: 13px;
    color: #8b8b8b;
    margin-bottom: 8px;
  }

  .expertise-items {
  }

  .item-container {
    display: flex;
    align-items: flex-start;
    align-self: flex-start;
  }
  .validate {
    align-self: end;
  }

  .item-form {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: fit-content;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 10px;
    min-width: 140px;
    margin: 5px 14px;
  }
  .caduc-item {
    background-color: #fff;
    box-shadow: 1px 1px 3px #d60e0e;
    border-radius: 4px;
    color: #c30b0b;
    font-size: 17px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 16px 16px;
    margin-right: 16px;
  }
  .caduc-position {
    align-self: center;
  }
  .accounting-form,
  .mechanical-form {
    display: flex;
    align-items: center;
    margin-top: -17px;
  }

  .medical-form {
    margin-top: -12px;
  }

  .global-expertise-container {
    width: 100%;
    margin: 0 auto;
  }

  .item-field,
  .medical-item-field,
  .mechanical-item-field {
    font-size: 13px;
    color: #2b2727;
    font-weight: bold;
    margin-right: 24px;
    width: 250px;
  }

  .medical-item-field {
    padding: 5px 0;
    margin: 10px;
  }

  .upload-document {
    margin: 18px 0;
    width: 50%;
  }

  .upload-document-button {
    font-weight: normal;
    font-size: 14px;
    min-width: 220px;
  }

  .MuiInputLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #8b8b8b;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }

  .medical-wrapper,
  .accounting-wrapper,
  .mechanical-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .expert-report-decision-wrapper {
    margin: 6px 5px;
    padding: 0 5px;
    position: relative;
    align-items: center;
  }

  .decision-button {
  }

  .expert-report-decision-recap-container {
    width: 350px;
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    align-items: left;
  }
  .decision-status,
  .contest-reason {
    padding: 8px 0;
    font-size: 14px;
    color: #2b2727;
  }

  .decision-status > *,
  .contest-reason > * {
    margin-right: 16px;
  }
  .decision-info > *,
  .contest-reason > * {
    margin-right: 16px;
  }
  .decision-info,
  .contest-reason {
    padding: 8px 0;
    font-size: 14px;
    color: #2b2727;
  }
  .decision-sub-bloc-title {
    font-weight: bold;
  }
  .decision-recap-container-title {
    font-weight: bold;
    font-size: 14px;
    color: #0072c6;
    text-transform: uppercase;
    padding: 5px 0;
  }
  .section {
    justify-content: flex-start;
    flex-direction: row;
    display: flex;
    align-items: center;
    line-height: 0px;
  }
`;
export const StyledTitleDrawer = {
  marginBottom: 10,
  marginTop: 10,
  fontSize: 17,
  fontWeight: 500,
  lineHeight: '28px',
};

export const StyledCard = {
  background: 'rgba(245, 247, 250, 1)',
  border: '1px solid rgba(213, 218, 225, 1)',
  padding: '16px',
  gap: '16px',
  height: '173px',
  borderRadius: '8px',
};
export const StyledTitle = {
  fontWeight: 500,
  lineHeight: '28px',
  fontSize: '20px',
};
export const StyledSubTitle = {
  fontWeight: 400,
  lineHeight: '24px',
  marginTop: '20px',
  fontSize: '16px',
};
export const StyledChoice = {
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: 15,
};
export const StyledTextField = {
  width: '100%',
  marginTop: '40px',
};
export const IstyledIcon = {
  width: '13.5px',
  height: '13.5px',
  color: 'rgba(0, 117, 201, 1)',
};
export const StyledUpdate = {
  fontWeight: 500,
  lineHeight: '16px',
  fontSize: '12px',
  color: 'rgba(0, 117, 201, 1)',
};
